import React, { Component } from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import i18n from "i18next";
import BlockUi from "react-block-ui";
import { Growl } from "primereact/growl";
import FormTextField from "../../../Component/FormTextField/FormTextField.component";
import SubmitButton from "../../../Component/SubmitButton/SubmitButton.component";
import loginVm from "../../../../ViewModel/LoginViewModel";
import { RadioButton } from "primereact/radiobutton";
import FormPhoneNumberField from "../../../Component/FormPhoneNumberField/FormPhoneNumberField.component";
import routingVM from "../../../../ViewModel/RoutingViewModel";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./Login.scss";
import "react-block-ui/style.css";
import { UD_X_CLIENT_URL } from "../../../../Common/constants";
import accountVM from "../../../../ViewModel/AccountVM";

export interface LoginState {
    username: string;
    password: string;
    ui_block: boolean;
    phoneNumber: string;
    username_choice: boolean;
    phone_choice: boolean;
}

export interface LoginProps extends RouteComponentProps { }

class Login extends Component<LoginProps, LoginState> {
    growl = React.createRef<any>();
    private phoneTextField = React.createRef<FormPhoneNumberField>();
    constructor(props: LoginProps) {
        super(props);
        this.state = {
            username: "",
            password: "",
            ui_block: false,
            phoneNumber: "",
            username_choice: true,
            phone_choice: false,
        };
    }

    componentDidMount() {
        try {
            const oldToken = accountVM.loadToken();
            this.checkVerify({
                tkn: oldToken.token,
                exp: oldToken.expires,
                cid: oldToken.cid,
                uid: oldToken.uid,
            })
        } catch (e) {
            // Do nothing
        }
    }

    onChangeUsername = (e: React.FormEvent<HTMLInputElement>) => {
        var val = (e.target as HTMLInputElement).value;
        val = val?.trim();
        this.setState({ username: val });
    };
    onChangePhoneNumber = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ phoneNumber: (e.target as HTMLInputElement).value });
    };
    onChangePassword = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ password: (e.target as HTMLInputElement).value });
    };

    checkVerify(data: any) {
        routingVM.data = data;
        const [, encodedBody,] = data?.tkn
            .toString()
            .split(".");
        const decoded = JSON.parse(atob(encodedBody));
        if (decoded.vrf === false) {
            this.props.history.push("/register/verify");
        } else {
            console.log(decoded.art)
            if (decoded.art === "UDUser") {
                window.location.replace((process.env.REACT_APP_REDIRECT_ADMIN_URL ?? "/uad") + `?xct=${UD_X_CLIENT_URL}&tkn=${accountVM.loadToken().token}`);
            } else {
                window.location.replace((process.env.REACT_APP_REDIRECT_URL ?? "/ud") + `?xct=${UD_X_CLIENT_URL}&tkn=${accountVM.loadToken().token}`);
            }
        }
    }

    onSubmit(e: any) {
        e.preventDefault();
        if (this.state.username_choice || this.state.phone_choice) {
            if (this.state.username_choice) {
                this.setState({ ui_block: true });
                loginVm
                    .loginByUsername(this.state.username, this.state.password)
                    .then((data) => {
                        this.growl.current.show({ detail: i18n.t("success-login") });
                        this.checkVerify(data);
                    })
                    .catch((error) => {
                        this.growl.current.show({ detail: i18n.t(error.message) });
                    })
                    .finally(() => {
                        this.setState({ ui_block: false });
                    });
            } else {
                if (!this.phoneTextField.current?.validate()) {
                    return;
                } else {
                    this.setState({ ui_block: true });
                    loginVm
                        .loginByPhoneNumber(this.state.phoneNumber, this.state.password)
                        .then((data) => {
                            this.growl.current.show({ detail: i18n.t("success-login") });
                            this.checkVerify(data);
                        })
                        .catch((error) => {
                            this.growl.current.show({ detail: i18n.t(error.message) });
                        })
                        .finally(() => {
                            this.setState({ ui_block: false });
                        });
                }
            }
        } else {
            return;
        }
    }

    render() {
        return (
            <div className="login-page">
                <BlockUi tag="div" blocking={this.state.ui_block}>
                    <Growl className="growl growl-p" ref={this.growl} />
                    <div className="text">
                        <span>{i18n.t("login-text")}</span>
                    </div>
                    <div className="login-form">
                        <form onSubmit={(e) => this.onSubmit(e)}>
                            <div className="radio-buttons row">
                                <div>
                                    <RadioButton
                                        inputId="username_radio"
                                        onChange={(e: any) =>
                                            this.setState({
                                                username_choice: true,
                                                phone_choice: false,
                                            })
                                        }
                                        checked={this.state.username_choice === true}
                                    />
                                    <label
                                        htmlFor="username_radio"
                                        className="p-radiobutton-label"
                                    >
                                        {i18n.t("by-username")}
                                    </label>
                                    &emsp;
                                </div>
                                <div>
                                    <RadioButton
                                        inputId="phone_radio"
                                        onChange={(e) =>
                                            this.setState({
                                                phone_choice: true,
                                                username_choice: false,
                                            })
                                        }
                                        checked={this.state.phone_choice === true}
                                    />
                                    <label htmlFor="phone_radio" className="p-radiobutton-label">
                                        {i18n.t("by-phone")}
                                    </label>
                                </div>
                            </div>
                            {this.state.username_choice && (
                                <FormTextField
                                    filter={/^[a-zA-Z0-9._]+$/}
                                    minLength="8"
                                    maxLength="20"
                                    id="username"
                                    type="text"
                                    value={this.state.username}
                                    onChange={(e) => {
                                        this.onChangeUsername(e);
                                    }}
                                    label={i18n.t("user-name")}
                                />
                            )}
                            {this.state.phone_choice && (
                                <FormPhoneNumberField
                                    ref={this.phoneTextField}
                                    filter={/^[0-9]+$/}
                                    minLength="9"
                                    maxLength="9"
                                    name="phoneNumber"
                                    type="tel"
                                    errorMsg={i18n.t("invalid-phone")}
                                    value={this.state.phoneNumber}
                                    onChange={(e: any) => {
                                        this.onChangePhoneNumber(e);
                                    }}
                                    label={i18n.t("phone-number")}
                                />
                            )}
                            <FormTextField
                                id="password"
                                type="password"
                                minLength="8"
                                maxLength="64"
                                value={this.state.password}
                                onChange={(e) => {
                                    this.onChangePassword(e);
                                }}
                                label={i18n.t("password")}
                            />
                            <div className="row">
                                <div className="col-lg-3 col-3" />
                                <div className="col-lg-6 col-6">
                                    <SubmitButton
                                        label="Success"
                                        className="login-btn p-button-success"
                                        content={i18n.t("login-btn")}
                                    />
                                </div>
                                <div className="col-lg-3 col-3" />
                            </div>
                        </form>
                    </div>
                </BlockUi>
            </div>
        );
    }
}

export default Login;